import { Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  Component,
  DestroyRef,
  inject,
  Input,
  OnInit,
  TemplateRef,
} from '@angular/core';
import { AsyncPipe, NgIf, NgTemplateOutlet } from '@angular/common';

import { SlotId } from './slot.types';
import { SlotService } from './slot.service';

@Component({
  selector: 'iss-slot',
  standalone: true,
  imports: [
    NgIf,
    NgTemplateOutlet,
    AsyncPipe,
  ],
  template: '<ng-container *ngIf="template$ | async as template"><ng-container [ngTemplateOutlet]="template"/></ng-container>',
})
export class SlotComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly service = inject(SlotService);
  public template$!: Observable<TemplateRef<unknown> | null>;

  @Input({ required: true }) id!: SlotId;

  public ngOnInit(): void {
    this.template$ = this.service.asObservable(this.id).pipe(takeUntilDestroyed(this.destroyRef));
  }
}
